var render = function render(){var _vm=this,_c=_vm._self._c;return _c('MainLayout',[_c('div',{attrs:{"id":"contents"}},[_c('Payment')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }